import React, { useState, useEffect } from "react";
import Main from "../Components/Main";
import PageContainer from "../Components/PageContainer";
import Modal from "../Components/Modal";
import CollapseCard from "../Components/CollapseCard";
import VendorAdvanceList from "../Components/VendorAdvanceList";
import VendorAdvanceForm from "../Components/VendorAdvanceForm";
import { saveAdvance, deleteAdvance, getAllAdvance, getAdvanceByVendorId } from "../Service/AdvanceService";
import { getAllVendors } from "../Service/VendorService";
import { useToast } from "../Components/toast/ToastProvider";
import { getPaymentHistoryByAdvance } from "../Service/VendorAdvanceService";
import PaymentHistoryList from "../Components/PaymentHistoryList";

const VendorAdvancePage = () => {
  const [advanceData, setAdvanceData] = useState([]);
  const [advanceForm, setAdvanceForm] = useState({
    date: new Date().toISOString().split("T")[0],
    vendor_id: "",
    amount: "",
    remarks: "",
    type: "Normal",
    status: "open",
  });
  const [vendors, setVendors] = useState([]);
  const [selectedVendorId, setSelectedVendorId] = useState('');
  const [showModal, setShowModal] = useState(false);
  const toast = useToast();
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [showModalHistory, setShowModalHistory] = useState(false);
  const [type, setType] = useState('');

  useEffect(() => {
    fetchAdvances();
    fetchVendors();
  }, []);


  const fetchVendors = async () => {
    try {
      const res = await getAllVendors();
      setVendors(res.data);
    } catch (err) {
      toast(err.message || "Failed to fetch vendors", "ERROR");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!advanceForm.date || !advanceForm.vendor_id || !advanceForm.amount || !advanceForm.remarks) {
      toast("Please fill all fields");
      return;
    }

    try {
      await saveAdvance(advanceForm);
      toast(advanceForm.id ? "Advance updated successfully" : "Advance added successfully", "SUCCESS");
      fetchAdvances();
      handleCancel();
    } catch (err) {
      toast(err.message || "Failed to save advance", "ERROR");
    }
  };

  const handleEdit = (item) => {
    setAdvanceForm({
      id: item.id,
      date: item.date,
      vendor_id: item.vendor_id,
      amount: item.amount,
      remarks: item.remarks,
      type: item.type,
      status: item.status,
    });
    setShowModal(true);
  };

  const handleDelete = async (index) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;
    try {
      await deleteAdvance(advanceData[index].id);
      toast("Advance deleted successfully", "SUCCESS");
      fetchAdvances();
    } catch (err) {
      toast(err.message || "Failed to delete advance", "ERROR");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAdvanceForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleCancel = () => {
    setAdvanceForm({
      date: new Date().toISOString().split("T")[0],
      vendor_id: "",
      amount: "",
      remarks: "",
      type: "Normal",
      status: "open",
    });
    setShowModal(false);
    setShowModalHistory(false);
  };

  const handleView = async (id, type) => {
    try {
      const res = await getPaymentHistoryByAdvance(id);
      console.log("res", res);


      const data = (res.data) ? res.data : [];
      setPaymentHistory(data);
      setShowModalHistory(true);
      setType(type);
      console.log("s", paymentHistory);

    } catch (err) {
      toast(err.message || "Failed to fetch payment history", "ERROR");
    }
  }

  const fetchAdvances = async () => {
    try {
      const res = await getAllAdvance();
      const advances = Array.isArray(res.data) ? res.data : [];

      const enriched = await Promise.all(
        advances.map(async (adv) => {

          try {
            const response = await getPaymentHistoryByAdvance(adv.id);
            console.log("res",response);
            

            const payment = response.data || [];

            const totalDeduction = payment.reduce((sum, p) => {
              if (adv.type === "Normal") {
                return sum + Number(p.nor_advance_deduction || 0);
              } else if (adv.type === "Receipt") {
                return sum + Number(p.res_advance_deduction || 0);
              }
              return sum;
            }, 0);


            return {
              ...adv,
              total_deduction: totalDeduction,
              balance_amount: Number(adv.amount || 0) - totalDeduction,
            };
          } catch (err) {
            return {
              ...adv,
              total_deduction: 0,
              balance_amount: Number(adv.amount || 0),
            };
          }
        })
      );

      const sortedAdvances = enriched.sort((a, b) => b.id - a.id);
      setAdvanceData(sortedAdvances);
    } catch (err) {
      toast(err.message || "Failed to fetch advances", "ERROR");
    }
  };

  const handleKeyDown = (e, nextFieldName) => {
    if (e.key === "Enter") {
      e.preventDefault();

    }
    const nextInput = document.querySelector(`input[name="${nextFieldName}"]`) ||
      document.querySelector(`input[type="radio"][name="${nextFieldName}"]`);
    if (nextInput) {
      nextInput.focus();
    }
  }

  return (
    <Main>
      <PageContainer
        titlePage="Vendor Advance"
        buttonText="ADD"
        onButtonClick={() => setShowModal(true)}
      >
        <Modal
          visible={showModal}
          size="lg"
          onClose={handleCancel}
          headerText={advanceForm.id ? "Edit Advance" : "Add Advance"}
        >
          <VendorAdvanceForm
            vendors={vendors}
            advanceForm={advanceForm}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            handleCancel={handleCancel}
            setVendors={vendors}
            setAdvanceForm={setAdvanceForm}
            handleKeyDown={handleKeyDown}
          />
        </Modal>

        <Modal
          visible={showModalHistory}
          size='lg'
          onClose={handleCancel}
          headerText='Payment History'>
          <PaymentHistoryList paymentHistory={paymentHistory}
            type={type} />
        </Modal>


        <CollapseCard title="Advance List">
          <VendorAdvanceList
            advanceData={advanceData}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            handleView={handleView}
            vendors={vendors}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default VendorAdvancePage;
